const api = {
	listStoreUsers: '/storeUser/listStoreUsers',      // 账号列表
	addStoreUser: '/storeUser/addStoreUser',        //添加账员
	deleteStoreUser: '/storeUser/deleteStoreUser',  //删除账号
	editStoreUser: '/storeUser/editStoreUser',      // 编辑账号
	getStoreUserDetail: '/storeUser/getStoreUserDetail',   // 查询账号详情
	listUserGroups: '/userGroup/listUserGroups', // 岗位列表
	changeStoreUserStatus: '/storeUser/changeStoreUserStatus',  // 修改账号状态
	changeStoreSuperAdministrator: '/storeUser/changeStoreSuperAdministrator', // 更换管理员
	sendVerificationCode: '/message/sendVerificationCode', // 发送验证码
	sendStoreVerificationCode: '/storeUser/sendVerificationCode', // 店铺发送验证码
	checkVerificationCode: '/message/checkVerificationCode' // 校验验证码
};

const routes = {
	'/staff-manage': '账号管理',
};

export { api, routes };
